/**
 * DoesNotComeFromConditionType - Condition qui vérifie si le joueur ne vient pas d'une étape spécifique
 * Identique à Java DoesNotComeFromCondition
 * Inverse de ComesFromCondition (StepVisitedConditionType)
 */

import {ConditionType} from '../types/ConditionType';
import {GameState} from '../../../models/GameState';
import GameStateHelper from '../../../helpers/GameStateHelper';

export class DoesNotComeFromConditionType implements ConditionType {
  typeName = 'COND_DOES_NOT_COMES_FROM';
  messageKey = 'laventurier.condition.does-not-come-from.name';
  descriptionKey = 'laventurier.condition.does-not-come-from.desc';
  errorKey = 'laventurier.condition.does-not-come-from.error';
  hasValue = true;
  hasAttribute = false;

  evaluate(gameState: GameState, condition: any): boolean {
    const comesFrom = condition.value || condition.stepNumber;
    if (!comesFrom) {
      console.log('[DoesNotComeFromConditionType] FALSE: no step number specified');
      return false;
    }

    const comesFromStr = comesFrom.toString().trim();
    
    // Récupérer le dernier chemin depuis recordedPaths
    const recordedPaths = gameState.data.recordedPaths || '';
    const pathParts = recordedPaths.split('-').filter((p) => p);
    const lastPath = pathParts.length > 0 ? pathParts[pathParts.length - 1] : '';

    // Vérifier si le dernier chemin n'est PAS égal à comesFrom
    const result = comesFromStr !== lastPath;
    console.log(`[DoesNotComeFromConditionType] ${result ? 'TRUE' : 'FALSE'}: comesFrom=${comesFromStr}, lastPath=${lastPath}`);
    return result;
  }
}
